import React from "react"
import { PropTypes } from "prop-types"
import UniqId from "uniqid"
import { withNamespaces } from "react-i18next"
import { compose } from "redux"
import Amenities from "../../common/constants/amenities"
import "./Amenity.scss"

const Amenity = props => {

  const { t } = props

  const amenity_translation = (jp_amenity) => {
    return props.lng == "ja" ? jp_amenity : Amenities[props.lng + "_translation_mapping"][jp_amenity]
  }

  return (
    <React.Fragment>
      {props.amenities_list.length > 0 && (
        <section>
          <h2>{t("amenity.title")}</h2>
          <ul styleName="amenity-list">
            {props.amenities_list.map((amenity) => {
              return (
                <li styleName="amenity-item" key={UniqId()}>{amenity_translation(amenity)}</li>
              )
            })}
          </ul>
        </section>
      )}
    </React.Fragment>
  )
}

Amenity.propTypes = {
  amenities_list: PropTypes.array.isRequired
}

export default compose(withNamespaces("listings"))(Amenity)
